import { render, staticRenderFns } from "./taskManageNew.vue?vue&type=template&id=4c204350&scoped=true&"
import script from "./taskManageNew.vue?vue&type=script&setup=true&lang=js&"
export * from "./taskManageNew.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./taskManageNew.vue?vue&type=style&index=0&id=4c204350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c204350",
  null
  
)

export default component.exports